import { computed, decorate, reaction } from 'mobx'
import { io } from 'socket.io-client'
import { NOTIFICATION_TYPES } from '../constants'
import moment from 'moment'
let socket
export default class SocketStore {
  constructor(store) {
    this.store = store
    this.initialize()
  }

  get shouldConnect() {
    return this.store.gamePk && this.store.auth.isAuthenticated
  }

  isSocketHealthy() {
    return socket?.connected && socket?.active
  }

  initialize() {
    if (this.shouldConnect) {
      this.connect()
    }

    this.connectReaction = reaction(
      () => ({
        shouldConnect: this.shouldConnect,
        env: this.store.info.env,
      }),
      ({ shouldConnect, env }) => {
        if (shouldConnect) {
          if (!this.isSocketHealthy()) {
            this.connect()
          } else {
            socket.emit('join', this.store.gamePk)
          }
        } else {
          this.disconnect()
        }
      }
    )
  }

  connect() {
    this.disconnect()

    let options = {
      transports: ['websocket'],
    }

    if (this.store.info.env == 'LOCAL') {
      options = 'http://localhost:3001'
    }

    socket = io(options)

    socket.on('connect', () => {
      socket.on('connections', (connections) => {
        let wasConnected = !!this.store.game.isConnected
        this.store.connections.replace(connections)
        if (wasConnected && !this.store.game.isConnected) {
          this.store.flash(NOTIFICATION_TYPES.SESSION_DISCONNECTED)
        }
      })

      if (this.store.gamePk) {
        socket.emit('join', this.store.gamePk)
      }

      socket.on('pitch', (pitchData) => {
        this.store.game.set('pitchData', pitchData)
      })

      socket.on('bossState', (data) => {
        // game state from currently connected boss operator
        const { gamePk, bossState, username } = data
        const { isAdminCorrection, ...rawBossState } = bossState

        if (username == this.store.auth.username) {
          return
        }

        if (gamePk != this.store.gamePk) {
          return
        }

        if (this.store.auth.isSuperUser && !this.store.game.isCorrecting) {
          const { trackingVersionId, ...rest } = rawBossState
          this.store.game.set('_bossState', rest)
          this.store.game.set('bossStateLastReceived', moment())
        }

        if (this.store.game.isConnected && isAdminCorrection) {
          this.store.game.receiveCorrection(rawBossState)
        }
      })
    })
  }

  disconnect() {
    if (socket && socket.connected) {
      socket.disconnect()
    }
  }
}

decorate(SocketStore, {
  shouldConnect: computed,
})
